import React from 'react'
import { connect } from 'react-redux'
import GroupsList from './Components/GroupsList/GroupsList'
import { getOmkGroupsRequest } from './Redux/actions'

class GroupApprovalDashboard extends React.Component {
  constructor(props) {
    super(props)
    this.getGroups = this.getGroups.bind(this)
  }

  // The first page is not requested here: GroupsList's table owns the page and
  // the page size, and asks for page 1 as it mounts. Fetching here as well
  // would either duplicate that request or contradict its page size.
  getGroups(payload) {
    this.props.dispatch(getOmkGroupsRequest(payload))
  }

  render() {
    const data = this.props.omgGroupApprovalData
    return (
      <GroupsList
        groups={data.groups}
        loader={data.groups_loader}
        error={data.groups_error}
        getGroups={this.getGroups}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    omgGroupApprovalData: state.omgGroupApprovalData
  }
}

export default connect(mapStateToProps)(GroupApprovalDashboard)
